// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__eTkFQ","loader":"MediumLoader_loader__sQydb","spinner-c7wet2":"MediumLoader_spinner-c7wet2__Ij0x1"};